var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.995 0C13.545 0 15 1.44 15 3.9975V11.0025C15 13.545 13.5525 15 11.0025 15H3.9975C1.44 15 0 13.545 0 11.0025V3.9975C0 1.44 1.44 0 3.9975 0H10.995ZM7.4925 4.1325C7.1475 4.1325 6.87 4.41 6.87 4.755V6.87H4.7475C4.5825 6.87 4.425 6.9375 4.305 7.05C4.1925 7.17 4.125 7.32675 4.125 7.4925C4.125 7.8375 4.4025 8.115 4.7475 8.1225H6.87V10.245C6.87 10.59 7.1475 10.8675 7.4925 10.8675C7.8375 10.8675 8.115 10.59 8.115 10.245V8.1225H10.245C10.59 8.115 10.8675 7.8375 10.8675 7.4925C10.8675 7.1475 10.59 6.87 10.245 6.87H8.115V4.755C8.115 4.41 7.8375 4.1325 7.4925 4.1325Z",
    fill: "#841474"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.c0652b6eb2c1303a4e766b00f442bb23.svg";
export { ForwardRef as ReactComponent };